import { Component, OnInit, Input } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';
import { EmployeeService } from '../employee.service';
import { CoursesService } from '../services/courses.service';
import Swal, { SweetAlertIcon } from 'sweetalert2';

@Component({
  selector: 'ngx-new-employee',
  templateUrl: './new-employee.component.html',
  styleUrls: ['./new-employee.component.scss'],
})
export class NewEmployeeComponent implements OnInit {
  @Input() stationId: string;
  user = {
    nns: '',
    name: '',
    role: 'Alta Dirección',
    curp: '',
    rfc: '',
    imss: '',
  };
  loading: boolean = false;

  courses = [];

  activities = {
    'Alta Dirección': [
      // tslint:disable-next-line: max-line-length
      'Revisar, analizar y autorizar conforme a las posibilidades económicas de la Organización, los recursos necesarios para el cumplimiento de los requisitos legales aplicables a la Estación de Servicio, garantizando la Seguridad Industrial, Seguridad Operativa y Protección al Medio Ambiente.',
    ],
    'Representante Técnico': [
      // tslint:disable-next-line: max-line-length
      'Llevar a cabo cursos de inducción, necesarios para mantener informado a todo el personal sobre el Sistema de Administración.',
      'Apoyar en la revisión de la política de la Organización.',
      // tslint:disable-next-line: max-line-length
      'Realizar una revisión y, en su caso, la actualización de la identificación de aspectos ambientales y peligros, al menos cuando ocurran accidentes, modificaciones que impliquen cambios en los equipos, instalaciones, productos comercializables o procesos originalmente aprobados en el permiso otorgado.',
      'Mantener informado al personal acerca de los requisitos legales aplicables a la Organización.',
    ],
    'Encargado de la estación': [
      'Control de abastecimiento de combustibles.',
      // tslint:disable-next-line: max-line-length
      'Supervisar el control de los inventarios de productos, para mantener existencias suficientes y ofrecer el servicio al cliente en el momento que se requiera.',
      'Revisar y dirigir al personal que se cumpla con el procedimiento de carga y descarga de combustible.',
      // tslint:disable-next-line: max-line-length
      'Validar los registros de ventas de turno, reportes de venta diaria, reembolsos de caja, depósitos bancarios y en general, toda la documentación comprobatoria antes de ser enviada al departamento de administración.',
      'Controlar el estado de operación de las instalaciones, maquinaria y equipos de la Estación de Servicio.',
      'Atender y las quejas y sugerencias de los clientes.',
      // tslint:disable-next-line: max-line-length
      'Coordinar la capacitación del personal en procedimientos para la atención a clientes. Supervisar la atención a los clientes.',
    ],
    'Despachador': [
      'Participar en las capacitaciones, cursos y pláticas que la Organización designe como necesarias.',
      // tslint:disable-next-line: max-line-length
      'Informar al Responsable Técnico cualquier anomalía detectada durante las actividades de suministro de combustible, a fin de identificar cualquier riesgo.',
      'Seguir las instrucciones de seguridad que determine el Responsable Técnico.',
    ],
    'Mantenimiento': [
      'Participar en las capacitaciones, cursos y pláticas que la Organización designe como necesarias.',
      'Cumplir con todas las medidas de seguridad que establezca el Responsable Técnico.',
      // tslint:disable-next-line: max-line-length
      'Reportar cualquier anomalía que se presente durante la ejecución de sus trabajos, que representen un riesgo para las personas, las instalaciones o el medio ambiente.',
    ],
    'Área Administrativa': [
      'Participar en las capacitaciones, cursos y pláticas que la Organización designe como necesarias.',
      // tslint:disable-next-line: max-line-length
      'Informar al Responsable Técnico cualquier anomalía detectada durante la ejecución de sus actividades, a fin de identificar cualquier riesgo.',
    ],
  };

  constructor(
    protected ref: NbDialogRef<NewEmployeeComponent>,
    private employeeService: EmployeeService,
    private courseService: CoursesService,
  ) { }

  async ngOnInit() {
    await this.getCoursesByRole(this.user.role);
  }

  close() {
    this.ref.close();
  }

  async createUser() {
    const dataHasEmptyValue = Object.values(this.user).includes('') || Object.values(this.user).includes(null);
    if (dataHasEmptyValue) {
      this.alert('Todos los campos son requeridos', 'error');
      return;
    }
    this.loading = true;
    const [error] = await this.employeeService.storeEmployee(this.stationId, this.user);
    this.loading = false;
    if (error) return this.alert('Ocurrio un error al intentar guardar la información, intenta más tarde por favor', 'error');
    this.alert('Empleado guardado con éxito');
    this.ref.close(true);
  }

  async getCoursesByRole(role: string) {
    this.courses = [];
    this.loading = true;
    const [err, courses] = await this.courseService.getCoursesByRole(role);
    if (err) { return this.alert('Ocurrio al cargar cursos, intenta más tarde por favor', 'error'); }
    for (const key in courses.data) await this.courses.push(courses.data[key].name);
    this.loading = false;
  }

  async alert(title: string = 'asdasd', type: SweetAlertIcon = 'success', text: string = '') {
    await Swal.fire({
      icon: type,
      title: title,
      text: text,
    });
  }

}
